module.exports = __webpack_public_path__ + "img/storyboard_lite_widgets.c22abe77.png";